import { makeStyles } from '@material-ui/core/styles';

import {
  PRIMARY_COLOR_APP,
  XMEI_PRIMARY_COLOR,
  XMEI_SECONDARY_COLOR,
} from '../../../consts/common';

export const useStyles = makeStyles((theme) => ({
  header: {
    color: PRIMARY_COLOR_APP,
    fontSize: 20,
    fontWeight: '400',
    marginLeft: 10,
    paddingVertical: 20,
    fontFamily: 'Roboto',
  },
  title: {
    color: PRIMARY_COLOR_APP,
    fontSize: 20,
    fontWeight: 'bold',
    marginLeft: 10,
    paddingVertical: 20,
    fontFamily: 'Roboto',
  },
  text: {
    fontSize: 14,
    fontWeight: 'bold',
    color: PRIMARY_COLOR_APP,
    fontFamily: 'Roboto',
  },
  textDocumentRequired: { color: PRIMARY_COLOR_APP, fontFamily: 'Roboto' },
  viewImageDescription: { flexDirection: 'row', marginTop: 10 },
  icon: {
    marginLeft: '8px',
    marginBottom: '4px',
    verticalAlign: 'middle',
  },
  bodyValue: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textValue: { fontSize: 16 },
  viewValue: { flexDirection: 'row' },
  submit: {
    margin: theme.spacing(4, 0, 2),
    backgroundColor: XMEI_SECONDARY_COLOR,
    color: '#FFF',
    fontWeight: 'bold',
    height: '45px',
    '&:hover': {
      backgroundColor: XMEI_PRIMARY_COLOR,
    },
  },
}));
